if (!customElements.get('pys-plan-purchase')) {
  customElements.define('pys-plan-purchase', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.mainButton = this.productInfo?.querySelector('.product-form__submit');
      this.panel = this.productInfo?.querySelector('.product__info-container');
      this.button = this.querySelector('[data-plan-submit]');
      if (!this.mainButton || !this.panel || !this.button) return;
      this.label = this.button.textContent;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const price = this.productInfo.querySelector('[id^="price-"]');
        const amount = price?.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item');
        this.querySelector('[data-plan-price]').textContent = amount?.textContent.trim() || price?.innerText.trim() || '';
        this.button.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        const unavailable = this.mainButton.disabled;
        const buttonLabel = unavailable ? this.mainButton.innerText.trim() : this.label;
        if (this.button.textContent !== buttonLabel) this.button.textContent = buttonLabel;
        if (!unavailable && this.mainButton.getAttribute('aria-disabled') !== 'true') {
          const label = this.mainButton.querySelector('span');
          if (label && label.textContent !== this.label) label.textContent = this.label;
        }
        const active = document.activeElement;
        const blockingUI = document.querySelector('cart-drawer.active, #cart-notification.active, [role="dialog"][open]');
        const teaser = document.querySelector('[data-testid="animated-teaser"]');
        const teaserBounds = teaser?.getBoundingClientRect();
        const teaserVisible = teaserBounds && teaserBounds.width > 0 && teaserBounds.bottom > 0 && teaserBounds.top < innerHeight;
        const bottom = teaserVisible ? Math.max(0, innerHeight - teaserBounds.top + 18) : 0;
        this.style.bottom = bottom + 'px';
        const overlapsFocus = active && !this.contains(active) && active !== document.body && active.getBoundingClientRect().bottom > innerHeight - this.offsetHeight - bottom;
        const consent = document.querySelector('#shopify-pc__banner');
        const consentVisible = consent && consent.getBoundingClientRect().height > 0;
        this.hidden = consentVisible || this.panel.getBoundingClientRect().bottom >= 0 || innerWidth >= 750 || !!blockingUI || overlapsFocus;
      };
      for (const event of ['scroll', 'resize']) window.addEventListener(event, this.update, { ...options, passive: true });
      document.addEventListener('focusin', this.update, options);
      document.addEventListener('focusout', () => requestAnimationFrame(this.update), options);
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.panel, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.cartObserver = new MutationObserver(this.update);
      const drawer = document.querySelector('cart-drawer, #cart-notification');
      if (drawer) this.cartObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.cartObserver?.disconnect(); }
  });
}

// Alternate visible story bands, independently of section type or template order.
// The hero and sticky navigation keep their existing white backgrounds.
if (!window.pysPlanStoryBands) {
  window.pysPlanStoryBands = true;
  const storySelector = '.pys-band:not(.pys-band--hero), .pys-plan-description, .pys-plan-sourcing';
  let scheduled = false;
  const updateStoryBands = () => {
    scheduled = false;
    const main = document.getElementById('MainContent');
    if (!main?.querySelector('[data-plan-product]')) return;
    let index = 0;
    main.querySelectorAll(storySelector).forEach((band) => {
      const visible = !band.closest('[hidden]') && band.getClientRects().length > 0 &&
        band.getBoundingClientRect().height > 0 && getComputedStyle(band).visibility !== 'hidden';
      if (!visible) {
        band.removeAttribute('data-pys-story-tone');
        return;
      }
      const tone = index++ % 2 === 0 ? 'grey' : 'white';
      if (band.dataset.pysStoryTone !== tone) band.dataset.pysStoryTone = tone;
    });
  };
  const scheduleStoryBands = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateStoryBands);
  };
  const startStoryBands = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;
    updateStoryBands();
    new MutationObserver((changes) => {
      if (changes.some((change) => change.type === 'childList' ||
        change.target.matches(`${storySelector}, .shopify-section`))) scheduleStoryBands();
    }).observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startStoryBands, { once: true });
  else startStoryBands();
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((event) =>
    document.addEventListener(event, scheduleStoryBands));
  window.addEventListener('resize', scheduleStoryBands, { passive: true });
}
